import { $, $$ } from '@utils';

function init() {
  if (!$('[data-au-download-file]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-download-file]').forEach((download) => {
    download.addEventListener('click', () => downloadFile(download.dataset.auDownloadFile));
  });
}

function downloadFile(url) {
  const aElement = document.createElement('a');
  aElement.setAttribute('download', '');
  aElement.href = url;
  aElement.setAttribute('target', '_blank');
  aElement.click();
  aElement.remove();
}

export default { init };
